@if (inited) {
  <sm-toolbar>
    <p-button [disabled]="!isChanged()" icon="fas fa-save" label="Speichern" (onClick)="save()">
    </p-button>
  </sm-toolbar>
  <sm-tab-view>
    <sm-tab header="Allgemein">
      <sm-form [form]="form"></sm-form>
    </sm-tab>
    <sm-tab header="Erlaubte Fächer">
      <sm-table [data]="allowedDomainsTable" [autoHeight]=true></sm-table>
    </sm-tab>
    <sm-tab header="Extra-Fächer">
      <sm-toolbar>
        <p-button icon="fas fa-plus" label="Neu" (onClick)="addSpecialDomain()">
        </p-button>
      </sm-toolbar>
      <sm-table [data]="specialDomainsTable" [allowRemoveRow]=true [handleRemove]=true [autoHeight]=true></sm-table>
    </sm-tab>
    <sm-tab header="Klassenämter">
      <div class="grid">
        <string-list-editor class="col-12" [ngModel]="settings.dutyNames">
        </string-list-editor>
      </div>
    </sm-tab>
    <sm-tab header="Belehrungstexte">
      <div class="grid">
        <string-list-editor class="col-12" [ngModel]="settings.instructionTexts">
        </string-list-editor>
      </div>
    </sm-tab>
    <sm-tab header="Lehrer">
      <sm-table [data]="teacherTable" [autoHeight]=true></sm-table>
    </sm-tab>
    <sm-tab header="Ferien">
      <sm-toolbar>
        <p-button icon="fas fa-plus" label="Neu" (onClick)="addHoliday()">
        </p-button>
      </sm-toolbar>
      <sm-table [data]="holidayTable" [allowRemoveRow]=true [handleRemove]=true [autoHeight]=true>
      </sm-table>
    </sm-tab>
    <sm-tab header="A/B Wochen">
      <p-message class="mb-4" severity="error">WICHTIG: Bitte zuerst unter Allgemein Start- und Enddatum des Schuljahres festlegen und speichern. Werden Start- oder Enddatum nachträglich geändert, verliert diese Zuordnung ihre Gültigkeit</p-message>
      <sm-table [data]="bWeeksTable" [autoHeight]=true></sm-table>
    </sm-tab>
  </sm-tab-view>
}
